/*eslint complexity: ["error", 25]*/

import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';

import FormRow from '../../../app/components/FormRow';
import { CreateUpdateCompanyDto } from '../../../common/spdCore/autogenerated/spdApiClient/models/CreateUpdateCompanyDto';
import DictionarySelector from '../Selects/DictionarySelector';

import CompanyByNameOrNipSelector from './CompanyByNameOrNipSelector';
import { CompanyGusButton } from './CompanyGusButton';

interface CompanyEditorTabDataProps {
  company: CreateUpdateCompanyDto;
  propertyChange: (obj: Partial<CreateUpdateCompanyDto>) => void;
  isGusLoading: boolean;
  findByNip: () => void;
  readOnly: boolean;
}

export const CompanyEditorTabData: React.FC<CompanyEditorTabDataProps> = ({
  company,
  propertyChange,
  isGusLoading,
  findByNip,
  readOnly,
}) => {
  return (
    <Form className="d-grid gap-3">
      <FormRow controlId="companyName" label="Nazwa">
        <Form.Control
          as="textarea"
          rows={3}
          value={company?.name || ''}
          onChange={e => propertyChange({ name: e.target.value })}
          disabled={readOnly}
        />
      </FormRow>
      <FormRow controlId="companyOfficialName" label="Nazwa oficjalna">
        <Form.Control
          as="textarea"
          rows={3}
          value={company?.officialName || ''}
          onChange={e => propertyChange({ officialName: e.target.value })}
          disabled={readOnly}
        />
      </FormRow>
      <FormRow controlId="address" label="Adres">
        <Form.Control
          type="text"
          value={company?.address || ''}
          onChange={e => propertyChange({ address: e.target.value })}
          disabled={readOnly}
        />
      </FormRow>
      <FormRow controlId="companyNIP" label="NIP PL/EU">
        <InputGroup>
          <Form.Control
            type="text"
            value={company?.nip || ''}
            onChange={e => propertyChange({ nip: e.target.value })}
            disabled={readOnly}
          />
          <CompanyGusButton
            readOnly={readOnly}
            nip={company?.nip}
            isLoading={isGusLoading}
            onClick={findByNip}
          />
        </InputGroup>
      </FormRow>
      <FormRow
        controlId="taxIdentifier"
        label="Identyfikator podatkowy (zagraniczny)"
      >
        <Form.Control
          type="text"
          value={company?.taxIdentifier || ''}
          onChange={e => propertyChange({ taxIdentifier: e.target.value })}
          disabled={readOnly}
        />
      </FormRow>
      {company?.taxIdentifier && (
        <FormRow
          controlId="taxCountryCode"
          label="Kod kraju identyfikatora podatkowego"
        >
          <DictionarySelector
            value={company?.taxCountryCodeId || ''}
            onChange={e =>
              propertyChange({
                taxCountryCodeId: e?.value,
                taxCountryCodeShortname: e?.badge,
              })
            }
            dictionary="Kod kraju"
            readOnly={readOnly}
            clearable={true}
            searchByShortname={true}
          />
        </FormRow>
      )}
      <FormRow controlId="email" label="E-mail">
        <Form.Control
          type="text"
          value={company?.email || ''}
          onChange={e => propertyChange({ email: e.target.value })}
          disabled={readOnly}
        />
      </FormRow>
      <FormRow controlId="emailInvoices" label="E-mail do faktur">
        <Form.Control
          type="text"
          value={company?.emailInvoices || ''}
          onChange={e => propertyChange({ emailInvoices: e.target.value })}
          disabled={readOnly}
        />
      </FormRow>
      <FormRow controlId="branch" label="Filia firmy">
        <CompanyByNameOrNipSelector
          value={company?.branchId || ''}
          onChange={e => propertyChange({ branchId: e.value })}
        />
      </FormRow>
      <FormRow controlId="active" label="Aktywna">
        <Form.Check
          type="checkbox"
          checked={company?.active !== false}
          onChange={e => propertyChange({ active: e.target.checked })}
        />
      </FormRow>
      <FormRow controlId="blockedForPrint" label="Blokada wydruków orzeczeń">
        <Form.Check
          type="checkbox"
          checked={company?.blockedForPrint ? true : false}
          onChange={e => propertyChange({ blockedForPrint: e.target.checked })}
        />
      </FormRow>
    </Form>
  );
};
